import { ShareStudyAreaRequest } from "src/app/predictor/interfaces/share-study-area-request";

// study-area.actions.ts
export class UpdateStudyAreaAccess {
  static readonly type = '[Study Area] Update Access';
  constructor(public shareStudyAreaRequest: ShareStudyAreaRequest) { }
}
